import { render, staticRenderFns } from "./BaseElSelect.vue?vue&type=template&id=5c471bca&scoped=true"
import script from "./BaseElSelect.vue?vue&type=script&lang=js"
export * from "./BaseElSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseElSelect.vue?vue&type=style&index=0&id=5c471bca&prod&scoped=true&lang=css"
import style1 from "./BaseElSelect.vue?vue&type=style&index=1&id=5c471bca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c471bca",
  null
  
)

export default component.exports